// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/.2.1.0@extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/.2.0.3@vue-style-loader!./~/.0.26.4@css-loader?{"minimize":true,"sourceMap":true}!./~/.11.1.4@vue-loader/lib/style-rewriter.js?{"id":"data-v-258dabdf","scoped":false,"hasInlineConfig":true}!./~/.6.0.3@sass-loader/lib/loader.js?{"sourceMap":true}!./~/.11.1.4@vue-loader/lib/selector.js?type=styles&index=0!./src/packages/widget/src/Widget.vue
// module id = 293
// module chunks = 0